import { useQuery } from '@tanstack/react-query';
import { useMe } from '../../../organisation/useMe';
import { segmentsApi } from '../../../apis';
import reFetchingHelper from '../../../common/reFetchingHelper';
import { InternalApiSegmentFullCalculationState } from '../../../api-internal';

interface QuerySegmentEventsProps {
  code: string;
  fullCalculationState?: InternalApiSegmentFullCalculationState;
}
export const useQuerySegmentEvents = ({ code, fullCalculationState }: QuerySegmentEventsProps) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    enabled: !!currentOrganisation?.id,
    queryKey: ['segmentEvents', code, currentOrganisation?.id],
    staleTime: 1_000,
    refetchInterval: () => {
      return fullCalculationState === 'STARTED'
        ? reFetchingHelper.getSegmentEventsReFetchIntervalWhenFullCalculationStarted()
        : reFetchingHelper.getSegmentEventsReFetchInterval();
    },
    queryFn: () => segmentsApi.findSegmentEvents({ code, limit: 10 }),
  });
};
